import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=60229207&scoped=true&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"
import style0 from "./invite.vue?vue&type=style&index=0&id=60229207&lang=less&scoped=true&"
import style1 from "./invite.vue?vue&type=style&index=1&id=60229207&lang=less&scoped=true&"
import style2 from "./invite.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60229207",
  null
  
)

export default component.exports